const OAUTH_APPLICATION_TYPES = {
  STANDARD: 'STANDARD',
  SHOPPING_AGENT: 'SHOPPING_AGENT'
};

const OAUTH_APPLICATION_TYPE_LABELS = {
  STANDARD: 'Standard',
  SHOPPING_AGENT: 'Shopping Agent'
};

module.exports = {
  OAUTH_APPLICATION_TYPES,
  OAUTH_APPLICATION_TYPE_LABELS
};
